<div class="header-container header-brand-container">
  <div class="logo-container">
    <a
      class="logo"
      href="#"
      aria-label="Go to dashboard"
      (click)="navigateHome(); $event.preventDefault()"
    >
      <img
        src="../../../../assets/images/logoBP.png"
        alt="Portus"
      />
    </a>
  </div>
</div>

<div class="header-container header-actions-container">
  <button
    nbButton
    ghost
    class="header-icon-button menu-btn"
    aria-label="Toggle navigation menu"
    (click)="toggleSidebar()"
  >
    <nb-icon icon="menu-2-outline"></nb-icon>
  </button>

  <nb-actions size="small">

    <!-- Global Search -->
    <nb-action class="control-item search-action">
      <button
        type="button"
        class="header-icon-button search-trigger"
        aria-label="Open global search"
        title="Search (Ctrl + K)"
        (click)="openGlobalSearch()"
      >
        <nb-icon icon="search-outline"></nb-icon>
      </button>
    </nb-action>

    <!-- Email -->
    <nb-action class="control-item">
      <button
        type="button"
        class="header-icon-button"
        aria-label="Open email"
        (click)="openEmail()"
      >
        <nb-icon icon="email-outline"></nb-icon>
      </button>
    </nb-action>

    <!-- Notifications -->
    <nb-action
      icon="bell-outline"
      class="control-item notification-action"
      [nbPopover]="notifList"
      nbPopoverPlacement="bottom"
      nbPopoverTrigger="click"
      [badgeText]="unreadCount > 0 ? unreadCount.toString() : ''"
      badgeStatus="danger"
      badgePosition="top right"
    >
    </nb-action>

    <ng-template #notifList>
      <nb-card class="notif-dropdown">
        <nb-card-header>
          <div class="notification-header">
            <span>Notifications</span>

            <span
              class="notif-count"
              *ngIf="unreadCount > 0"
            >
              {{ unreadCount }} new
            </span>
          </div>
        </nb-card-header>

        <nb-card-body *ngIf="groupedNotifications.length; else noNotif">
          <div
            *ngFor="let group of groupedNotifications"
            class="notif-group"
          >
            <div class="notif-group-title">
              {{ group.label }}
            </div>

            <button
              type="button"
              *ngFor="let n of group.items"
              class="notif-item"
              (click)="openNotification(n)"
            >
              <div class="notif-item-main">
                <div class="notif-text">
                  <b>{{ n.title }}</b>
                  <p>{{ n.message }}</p>

                  <small>
                    {{ n.createdAt?.toDate?.() | date: 'shortTime' }}
                  </small>
                </div>

                <div
                  *ngIf="!n.read"
                  class="unread-dot"
                ></div>
              </div>
            </button>
          </div>
        </nb-card-body>

        <ng-template #noNotif>
          <div class="empty-notification-state">
            No notifications
          </div>
        </ng-template>

        <nb-card-footer>
          <button
            nbButton
            size="tiny"
            fullWidth
            status="primary"
            (click)="goToNotifications()"
          >
            View all
          </button>
        </nb-card-footer>
      </nb-card>
    </ng-template>
  </nb-actions>
</div>

<!-- =========================================================
     GLOBAL SEARCH OVERLAY
========================================================= -->

<div
  *ngIf="globalSearchOpen"
  class="global-search-backdrop"
  role="presentation"
  (mousedown)="onSearchBackdropMouseDown($event)"
>
  <section
    class="global-search-modal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="global-search-title"
    (mousedown)="$event.stopPropagation()"
  >
    <!-- Search Header -->
    <header class="global-search-header">
      <div class="global-search-input-shell">
        <nb-icon icon="search-outline"></nb-icon>

        <input
          #globalSearchInput
          id="global-search-title"
          type="text"
          autocomplete="off"
          spellcheck="false"
          aria-label="Search jobs, customers, vouchers and accounts"
          placeholder="Search jobs, customers, vouchers, accounts, forms..."
          [value]="searchQuery"
          (input)="onGlobalSearchInput($event)"
          (keydown)="onSearchInputKeydown($event)"
        />

        <div class="search-header-actions">
          <span class="escape-label">Esc to close</span>

          <button
            type="button"
            class="search-close-button"
            aria-label="Close search"
            (click)="closeGlobalSearch()"
          >
            <nb-icon icon="close-outline"></nb-icon>
          </button>
        </div>
      </div>

      <!-- Categories -->
      <div class="search-category-list">
        <button
          type="button"
          *ngFor="let category of searchCategories"
          class="search-category-chip"
          [class.active]="activeSearchCategory === category.key"
          (click)="selectSearchCategory(category.key)"
        >
          <nb-icon [icon]="category.icon"></nb-icon>
          <span>{{ category.label }}</span>

          <span
            class="category-count"
            *ngIf="category.key !== 'all'"
          >
            {{ getCategoryCount(category.key) }}
          </span>
        </button>
      </div>
    </header>

    <!-- Search Body -->
    <main class="global-search-body">

      <!-- Initial State -->
      <div
        *ngIf="!searchQuery.trim()"
        class="search-initial-state"
      >
        <div class="search-welcome">
          <div class="search-welcome-icon">
            <nb-icon icon="search-outline"></nb-icon>
          </div>

          <div>
            <h2>Search Portus</h2>
            <p>
              Find jobs, customers, vouchers, accounts and important forms
              from one place.
            </p>
          </div>
        </div>

        <section class="initial-search-section">
          <div class="search-section-heading">
            <div>
              <span class="section-eyebrow">Quick access</span>
              <h3>Common actions</h3>
            </div>


          </div>

          <div class="quick-action-grid">
            <button
              type="button"
              *ngFor="let action of quickActions"
              class="quick-action-card"
              (click)="runQuickAction(action)"
            >
              <span
                class="quick-action-icon"
                [ngClass]="action.tone"
              >
                <nb-icon [icon]="action.icon"></nb-icon>
              </span>

              <span class="quick-action-copy">
                <strong>{{ action.title }}</strong>
                <small>{{ action.description }}</small>
              </span>

              <nb-icon
                class="quick-action-arrow"
                icon="arrow-forward-outline"
              ></nb-icon>
            </button>
          </div>

                      <div>
    <span class="section-eyebrow">
      Recently searched
    </span>

    <h3>Recent searches</h3>
  </div>

  <button
    type="button"
    class="clear-recent-searches"
    (click)="clearRecentSearches()"
  >
    Clear all
  </button>
        </section>

        <section class="initial-search-section"
        *ngIf="recentSearches.length">
          <div class="search-section-heading">
            <div>
              <span class="section-eyebrow">Recently searched</span>
              <h3>Recent searches</h3>
            </div>
          </div>

          <div class="recent-search-list">
            <div
  *ngFor="let item of recentSearches"
  class="recent-search-item"
  role="button"
  tabindex="0"
  (click)="useRecentSearch(item)"
  (keydown.enter)="useRecentSearch(item)"
>
  <nb-icon icon="clock-outline"></nb-icon>

  <span>{{ item }}</span>

  <button
    type="button"
    class="recent-search-remove"
    aria-label="Remove recent search"
    (click)="removeRecentSearch(item, $event)"
  >
    <nb-icon icon="close-outline"></nb-icon>
  </button>
</div>
          </div>
        </section>
      </div>

      <!-- Loading State -->
      <div
        *ngIf="searchQuery.trim() && searchLoading"
        class="search-loading-state"
      >
        <div
          class="search-result-skeleton"
          *ngFor="let row of skeletonRows"
        >
          <div class="skeleton-avatar"></div>

          <div class="skeleton-content">
            <span class="skeleton-line skeleton-line-lg"></span>
            <span class="skeleton-line skeleton-line-md"></span>
            <span class="skeleton-line skeleton-line-sm"></span>
          </div>
        </div>
      </div>

      <!-- Results State -->
      <div
        *ngIf="
          searchQuery.trim() &&
          !searchLoading &&
          filteredSearchResults.length
        "
        class="search-results-layout"
      >
        <!-- Results List -->
        <section class="search-results-panel">
          <div class="search-results-summary">
            <div>
              <span class="section-eyebrow">Search results</span>

              <h2>
                Results for “{{ searchQuery }}”
              </h2>
            </div>

            <span class="result-total">
              {{ filteredSearchResults.length }}
              result{{ filteredSearchResults.length === 1 ? '' : 's' }}
            </span>
          </div>

          <ng-container
            *ngFor="let group of groupedSearchResults"
          >
            <section
              class="result-group"
              *ngIf="group.items.length"
            >
              <div class="result-group-heading">
                <div>
                  <nb-icon [icon]="group.icon"></nb-icon>
                  <span>{{ group.label }}</span>
                </div>

                <span>{{ group.items.length }}</span>
              </div>

              <button
  type="button"
  *ngFor="let result of group.items"
  class="global-result-card"
  [class.selected]="isSearchResultSelected(result)"
  [attr.aria-pressed]="isSearchResultSelected(result)"

  (mousedown)="selectSearchResult(result, $event)"
>
  <span
    class="result-icon"
    [ngClass]="'result-icon-' + result.type"
  >
    <nb-icon [icon]="result.icon"></nb-icon>
  </span>

  <span class="result-main">
    <span class="result-title-row">
      <strong
        [innerHTML]="highlightText(result.title)"
      ></strong>

      <span
        *ngIf="result.status"
        class="result-status"
        [ngClass]="getStatusClass(result.status)"
      >
        {{ result.status }}
      </span>
    </span>

    <span class="result-subtitle">
      {{ result.subtitle }}
    </span>

    <span
      *ngIf="result.meta?.length"
      class="result-meta"
    >
      <ng-container
        *ngFor="
          let meta of result.meta;
          let last = last
        "
      >
        <span>{{ meta }}</span>
        <i *ngIf="!last"></i>
      </ng-container>
    </span>
  </span>

  <span class="result-side">
    <span class="matched-field">
      Matched: {{ result.matchedField }}
    </span>
  </span>
</button>
            </section>
          </ng-container>
        </section>

        <!-- Preview Panel -->
        <aside
          class="search-preview-panel"
          *ngIf="selectedSearchResult as selected"
        >
          <div class="preview-topbar">
            <span
              class="preview-type-badge"
              [ngClass]="'preview-type-' + selected.type"
            >
              {{ getResultTypeLabel(selected.type) }}
            </span>

            <div class="preview-topbar-actions">
              <button
                type="button"
                aria-label="Add to favourites"
              >
                <nb-icon icon="star-outline"></nb-icon>
              </button>

              <button
                type="button"
                aria-label="More actions"
              >
                <nb-icon icon="more-vertical-outline"></nb-icon>
              </button>
            </div>
          </div>

          <div class="preview-identity">
            <span
              class="preview-avatar"
              [ngClass]="'preview-avatar-' + selected.type"
            >
              {{ selected.initials }}
            </span>

            <div>
              <h2>{{ selected.title }}</h2>
              <p>{{ selected.subtitle }}</p>

              <span>
                Matched: {{ selected.matchedField }}
              </span>
            </div>
          </div>

          <div class="preview-metrics">
            <article
              *ngFor="let metric of selected.metrics"
            >
              <span>{{ metric.label }}</span>
              <strong [ngClass]="metric.tone">
                {{ metric.value }}
              </strong>
            </article>
          </div>

          <div class="preview-actions">
  <button
    type="button"
    class="preview-primary-action"
    (click)="openSelectedSearchResult()"
  >
    <nb-icon icon="external-link-outline"></nb-icon>
    <span>{{ selected.primaryActionLabel }}</span>
  </button>
</div>



          <section
            class="preview-section"
            *ngIf="selected.details?.length"
          >
            <h3>Summary</h3>

            <dl>
              <div
                *ngFor="let detail of selected.details"
              >
                <dt>
                  <nb-icon [icon]="detail.icon"></nb-icon>
                  {{ detail.label }}
                </dt>

                <dd>{{ detail.value }}</dd>
              </div>
            </dl>
          </section>

          <section
            class="preview-section preview-activity-section"
            *ngIf="selected.activities?.length"
          >
            <h3>Recent activity</h3>

            <div class="preview-activity-list">
              <article
                *ngFor="let activity of selected.activities"
              >
                <span class="activity-dot"></span>

                <div>
                  <strong>{{ activity.title }}</strong>
                  <p>{{ activity.description }}</p>
                </div>

                <time>{{ activity.date }}</time>
              </article>
            </div>
          </section>
        </aside>
      </div>

      <!-- No Results -->
      <div
        *ngIf="
          searchQuery.trim() &&
          !searchLoading &&
          !filteredSearchResults.length
        "
        class="search-empty-state"
      >
        <div class="search-empty-icon">
          <nb-icon icon="search-outline"></nb-icon>
        </div>

        <h2>No results for “{{ searchQuery }}”</h2>

        <p>
          Try searching by job number, HBL, MBL, voucher number,
          customer name or account.
        </p>

        <button
          type="button"
          (click)="clearGlobalSearch()"
        >
          Clear search
        </button>
      </div>
    </main>

    <!-- Footer -->
    <footer class="global-search-footer">
      <div class="keyboard-shortcuts">
        <span>
          <kbd>↑</kbd>
          <kbd>↓</kbd>
          Navigate
        </span>

        <span>
          <kbd>Enter</kbd>
          Open
        </span>

        <span>
          <kbd>Tab</kbd>
          Preview
        </span>

        <span>
          <kbd>Esc</kbd>
          Close
        </span>
      </div>

      <span class="search-system-label">
        Portus Global Search
      </span>
    </footer>
  </section>
</div>